<div class="grid gap-x-4 sm:grid-cols-1 md:grid-cols-2">
  <div class="_g-detail-wrapper _g-border-dashed">
    <div class="_g-content-detail flex">
      <img
        [src]="purchaseProductData.productImageUrl"
        class="_product-imageUrl"
        imageFallback
      />
    </div>
    @if (isBulkSale) {
      <span class="w-1/4 font-semibold">ลายเซ็นรับซื้อ: </span>
      <div class="_g-content-detail flex">
        <img
          [src]="purchaseProductData.signatureImageUrl"
          class="_product-imageUrl"
          imageFallback
        />
      </div>
    }
  </div>

  <div class="_g-detail-wrapper">
    <div class="_wrapper">
      <span class="_left w-[100px]">{{ "product" | translate }}</span>
      <span>{{ product.translations | translations: "name" }} </span>
    </div>
    @if (isBulkSale) {
      <div class="_wrapper">
        <span class="_left w-[100px]">{{ "weighing.weighingIn" | translate }}</span>
        <span>{{ purchaseProductData.weightIn | number: "1.2" : "en-US" }} ตัน </span>
      </div>
      <div class="_wrapper">
        <span class="_left w-[100px]">{{ "purchaseDetailList.weightOut" | translate }}</span>
        <span>{{ purchaseProductData.weightOut | number: "1.2" : "en-US" }} ตัน</span>
      </div>
    }

    <div class="_wrapper">
      <span class="_left w-[100px]">{{ "purchaseDetailList.weighingWeight" | translate }}</span>
      <span>{{ purchaseProductData.weight | number: "1.2" : "en-US" }} </span>
    </div>
    <div class="_wrapper">
      <span class="_left w-[100px]">{{ "purchaseDetailList.weightLoss" | translate }}</span>
      <span>{{ purchaseProductData.weightLoss | number: "1.2" : "en-US" }} </span>
    </div>
    <div class="_wrapper">
      <span class="_left w-[100px]">{{ "price" | translate }}</span>
      <span>
        {{ purchaseProductData.pricePerUnit | number: "1.2" : "en-US" }} {{ "franchiseTier.baht" | translate }}
    
      </span>
    </div>
    <div class="_wrapper">
      <span class="_left w-[100px]">{{ "purchaseDetailList.specialPrice" | translate }}</span>
      <span
        >{{ purchaseProductData.specialPricePerUnit | number: "1.2" : "en-US" }}
        @if (purchaseProductData.useSpecialPrice) {
          <p-tag
            class="ml-2 mt-1"
            severity="success"
            [value]="'purchaseDetailList.useSpecialPrice' | translate"
            rounded
          />
        }
      </span>
    </div>
    <div class="_wrapper">
      <span class="_left w-[100px]">{{ "purchaseDetailList.netPrice" | translate }}</span>
      <span>{{ purchaseProductData.sumAmount | number: "1.2" : "en-US" }} </span>
    </div>
    <div class="_wrapper">
      <span class="_left w-[100px]">{{ "weighing.weight" | translate }}</span>
      <span>{{ purchaseProductData.weightTotal | number: "1.2" : "en-US" }} </span>
    </div>
    <div class="_wrapper">
      <span class="_left w-[100px]">{{ "note" | translate }}</span>
      <span>{{ purchaseProductData.remark }} </span>
    </div>
  </div>
</div>
